import { render, staticRenderFns } from "./RedactarDocumentos.vue?vue&type=template&id=0b553b46&scoped=true"
import script from "./RedactarDocumentos.vue?vue&type=script&lang=js"
export * from "./RedactarDocumentos.vue?vue&type=script&lang=js"
import style0 from "./RedactarDocumentos.vue?vue&type=style&index=0&id=0b553b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b553b46",
  null
  
)

export default component.exports